export class OrderBookingStatusReferenceModel {
    public orderBookingStatusCode: string;
    public orderBookingStatusName: string;
    public statusCode: string;
}